<div style="height: 40px">
    <p class="highChartStyleTitle">
        @if(this.routerLink) {
            <a [routerLink]="routerLink">{{title}}</a>
        } @else {
            {{title}}
        }
    </p>
    <p class="highChartStyleSubTitle">{{subTitle}}</p>
</div>